module.exports = __webpack_public_path__ + "img/pic_4.26836a70.png";